import React from "react";
import DataTable from "react-data-table-component";
import ClipLoader from "react-spinners/ClipLoader";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { TbEdit, TbSettings, TbTrash } from "react-icons/tb";

function ContactsTable({
  load,
  data,
  total,
  handlePageChange,
  handlePerRowsChange,
  toggle,
  toggleDelete,
}) {
  
  const getFormatedValue = (type, value) => {
    switch (type) {
      case 1:
        return value;
      case 2:
        return value;
      case 4:
        return value !== "0" ? "Да" : "Нет";
      default:
        return value;
    }
  };

  const paginationOptions = {
    rowsPerPageText: "Данных на странице:",
    rangeSeparatorText: "из",
    noRowsPerPage: false,
    selectAllRowsItem: false,
    selectAllRowsItemText: "Все",
  };
  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Название</span>,
      selector: (row) => row.Key,
      sortable: true,
      width: "60%",
    },
    {
      name: <span className="font-weight-bold fs-13">Значение</span>,
      selector: (row) => `${row.Lastname} ${row.Firstname}`,
      sortable: true,
      width: "30%",
      cell: (cellProps) => {
        return (
          <span>{getFormatedValue(cellProps.IdType, cellProps.Value)}</span>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Действия</span>,
      sortable: false,
      width: "10%",
      center: true,
      compact: true,
      cell: (cellProps) => {
        return (
          <UncontrolledDropdown className="dropdown d-inline-block">
            <DropdownToggle
              className="btn btn-outline-secondary btn-sm d-flex justify-content-center"
              tag="button"
            >
              <TbSettings size={18} />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem
                className="edit-item-btn"
                onClick={() => toggle(cellProps)}
              >
                <TbEdit size={16} className="me-2" />
                Изменить
              </DropdownItem>
              {cellProps.Id && cellProps.Id > 0 ? (
                <DropdownItem
                  className="remove-item-btn"
                  onClick={() => {
                    toggleDelete(cellProps);
                  }}
                >
                  <TbTrash size={16} className="me-2" />
                  Удалить
                </DropdownItem>
              ) : null}
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={data}
      progressComponent={<ClipLoader />}
      progressPending={load}
      paginationTotalRows={total}
      onChangeRowsPerPage={handlePerRowsChange}
      onChangePage={handlePageChange}
      pagination
      paginationServer
      paginationComponentOptions={paginationOptions}
    />
  );
}

export default ContactsTable;
